import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import React, { Suspense, lazy, useRef, useEffect, useState } from "react";
import "./assets/index.css";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Navbar from "./layout/Navbar/index";
import Footer from "./layout/Footer";
import WelcomeModal from "./components/modals/WelcomeModal";
import { ToastContainer } from "react-toastify";
import { useCookies } from "react-cookie";
import { useSelector, useDispatch } from "react-redux";
import {
  logout,
  selectCompletedBono,
  selectCurrency,
  selectDetectedCountry,
  selectDocumentoValidado,
  selectId,
  selectIdTotalPago,
  selectIsVerified,
  selectLogged,
  selectNotVerifiedPeru,
  selectToken,
  selectTotalPago,
  selectUser,
  setBlockDeposit,
  setBlockNotVerifiedPeru,
  setBlockRetiro,
  setDetectedCountry,
  setIdTotalPago,
  setNewToken,
  setTotalPago,
  setUserLoginDetails,
  setVerificaciones,
  updateBalance,
} from "./features/user/userSlice";
import { API_URL } from "./const/api";
import LoaderFull from "./components/LoaderFull";
import Afiliados from "./pages/Afiliados";
import LoginPage from "./pages/Login";
import {
  selectWelcomeModal,
  setShowWelcomeModal,
} from "./features/modals/modalsSlice";
import CambiarPassword from "./pages/CambiarPassword";
import CompletarDatos from "./pages/CompletarDatos";
import Policy from "./pages/Policy";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "./const/colors";
import { errorNotification } from "./utils/toastNotifications";
import { guardarIdioma } from "./utils/localStorage";
import BlockPage from "./components/BlockPage";
import CompletedBonoEffect from "./components/CompletedBonoEffect";
import DateTimeBanner from "./components/DateTimeBanner";
import {
  clearLimites,
  selectLimites,
  setLimites,
} from "./features/limitaciones/limitacionesSlice";
import { comprobarTiempoInactivo } from "./utils/tools";
import axiosInstance from "./utils/axiosInstance";

const Home = lazy(() => import("./pages/Home"));
const Horses = lazy(() => import("./pages/Horses"));
const Casino = lazy(() => import("./pages/Casino"));
const Esports = lazy(() => import("./pages/Esports"));
const Slots = lazy(() => import("./pages/Slots"));
const Alrojovivo = lazy(() => import("./pages/Alrojovivo"));
// const Slotsiframetop = lazy(() => import('./pages/IframeCasino'));
const ContactForm = lazy(() => import("./pages/ContactForm"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const Profile = lazy(() => import("./pages/Profile"));
const Error404 = lazy(() => import("./components/Error404"));
const CuentaInactiva = lazy(() => import("./components/CuentaInactiva"));
const JoinUs = lazy(() => import("./pages/JoinUs"));
const Sports = lazy(() => import("./pages/Sports"));
const Virtuals = lazy(() => import("./pages/Virtuals"));
const Poker = lazy(() => import("./pages/Poker"));
const VirtualGolden = lazy(() => import("./pages/VirtualGolden"));
/* SEO */
const DiasParaJugarTragamonedas = lazy(() =>
  import("./pages/SEO/blog/DiasParaJugarTragamonedas")
);
const JuegosDeCasinoOnline = lazy(() =>
  import("./pages/SEO/blog/JuegosDeCasinoOnline")
);
const MejoresCasasDeApuestasDeportivas = lazy(() =>
  import("./pages/SEO/blog/MejoresCasasDeApuestasDeportivas")
);
const ApuestasDeportivasArgentina = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasArgentina")
);
const ApuestasDeportivasChile = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasChile")
);
const ApuestasDeportivasFutbol = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasFutbol")
);
const ApuestasDeportivasMexico = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasMexico")
);
const ApuestasDeportivasNBA = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasNBA")
);
const ApuestasDeportivasOnline = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasOnline")
);
const BingoVirtualOnline = lazy(() => import("./pages/SEO/BingoVirtualOnline"));
const JugarBlackjackOnline = lazy(() =>
  import("./pages/SEO/JugarBlackjackOnline")
);
const MaquinasTragaMonedasOnline = lazy(() =>
  import("./pages/SEO/MaquinasTragaMonedasOnline")
);
const SeoCarrerasDeCaballosEnVivo = lazy(() =>
  import("./pages/SEO/SeoCarrerasDeCaballosEnVivo")
);
const SeoCasinoOnlineArgentina = lazy(() =>
  import("./pages/SEO/SeoCasinoOnlineArgentina")
);
const ApuestasDeportivasPeru = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasPeru")
);
const ApuestasDeportivasVenezuela = lazy(() =>
  import("./pages/SEO/ApuestasDeportivasVenezuela")
);
const SeoCasinoOnlineChile = lazy(() =>
  import("./pages/SEO/SeoCasinoOnlineChile")
);
const SeoCasinoOnlineEcuador = lazy(() =>
  import("./pages/SEO/SeoCasinoOnlineEcuador")
);
const SeoCasinoOnlinePeru = lazy(() =>
  import("./pages/SEO/SeoCasinoOnlinePeru")
);
const SeoCasinoOnlineVenezuela = lazy(() =>
  import("./pages/SEO/SeoCasinoOnlineVenezuela")
);
const SeoCasinoOnline = lazy(() => import("./pages/SEO/SeoCasinoOnline"));
const SeoPokerOnline = lazy(() => import("./pages/SEO/SeoPokerOnline"));
const SeoRuletaOnline = lazy(() => import("./pages/SEO/SeoRuletaOnline"));

const TIMEOUT_INACTIVITY = 30 * 60 * 1000; // 30 minutos en milisegundos

function App() {
  const isLoged = useSelector(selectLogged);
  const open = useSelector(selectWelcomeModal);
  const usuario = useSelector(selectUser);
  const id_uo = useSelector(selectId);
  const moneda = useSelector(selectCurrency);
  const completedBono = useSelector(selectCompletedBono);
  const [blockPage, setBlockPage] = useState(false);
  const country = useSelector(selectDetectedCountry);

  const [t, i18n] = useTranslation("global");
  const dispatch = useDispatch();
  const [cookies, removeCookie] = useCookies(["user"]);
  const token = useSelector(selectToken);
  const [hideNav, setHideNav] = useState(false);
  const totalPago = useSelector(selectTotalPago);
  const id_totalPago = useSelector(selectIdTotalPago);
  const documento_valido = useSelector(selectDocumentoValidado);
  const verified = useSelector(selectIsVerified);

  const notVerifiedPeru = useSelector(selectNotVerifiedPeru);

  const limitaciones = useSelector(selectLimites);

  // cerrar sesion si el usuario esta inactivo
  const timeoutRef = useRef(null);

  // Función para reiniciar los temporizadores cuando el usuario interactúa
  const resetTimeout = () => {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      handleInactivity();
    }, TIMEOUT_INACTIVITY);
  };

  useEffect(() => {
    if (!isLoged) return;

    // Función para reiniciar el temporizador en cualquier actividad
    const handleActivity = () => resetTimeout();

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("click", handleActivity);

    resetTimeout();

    return () => {
      clearTimeout(timeoutRef.current);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("click", handleActivity);
    };
  }, [isLoged]);

  const handleInactivity = () => {
    Swal.fire({
      title: t("home.inactividad"),
      text: "",
      icon: "warning",
      background: SECONDARY,
      color: "#fff",
      confirmButtonColor: PRIMARY,
      confirmButtonText: "Ok",
    }).then((result) => {
      dispatch(logout({}));
      dispatch(clearLimites({}));
      removeCookie("MBA");
      removeCookie("MBB");
      window.location.href = "/";
    });
  };
  //cerrar sesion si el usuario esta inactivo

  const handleClose = () => {
    dispatch(setShowWelcomeModal(false));
  };

  useEffect(() => {
    if (isLoged) {
      const getVerificacion = async () => {
        const res = await axios.post(API_URL + "getVerificaciones", { id_uo });

        if (res.data.status === 1) {
          const { validacion_documento, verified } = res.data.response;

          dispatch(setVerificaciones({ validacion_documento, verified }));
          if (validacion_documento == 0 || verified == 0) {
            //console.log("validacion_documento", validacion_documento, verified);
            dispatch(setBlockRetiro(true));
          }

          /* if(validacion_documento==0||verified==0||depositos==1) {
            console.log("usuario viejo no verificado")
            dispatch(setBlockRetiro(true))
          } else if(validacion_documento==0||verified==0||depositos==0) {
            console.log("usuario nuevo no verificado")
            dispatch(setBlockRetiro(true))
            dispatch(setBlockDeposit(true))
          }  */
          //if(validacion_documento==1||verified==1||depositos==1) dispatch(setBlockNotVerifiedPeru(false))
          //else dispatch(setBlockNotVerifiedPeru(true))
          //console.log("sin verificar", validacion_documento, verified, depositos)
        }
      };

      getVerificacion();
    }
  }, [isLoged]);

  useEffect(() => {
    if (isLoged) {
      if (documento_valido == 1) {
        dispatch(setBlockRetiro(false));
      }
    }
  }, [documento_valido, verified]);

  useEffect(() => {
    const loadData = async () => {
      const des = await axios.post(API_URL + "mostrar", {
        a: cookies.MBA,
        b: cookies.MBB,
      });
      if (des.data) {
        const res = await axios.post(API_URL + "auth", {
          user: des.data.ades,
          password: des.data.bdes,
        });
        if (res.data.status === 1) {
          if (res.data.estado !== "1") {
            removeCookie("MBA");
            removeCookie("MBB");
            Swal.fire({
              title: t("alert.errorNotificationRetiro-71")` "${res.data.user}"`,
              text: t("alert.errorNotificationRetiro-71"),
              icon: "error",
              background: SECONDARY,
              color: "#fff",
              confirmButtonColor: PRIMARY,
            });
          } else {
            dispatch(setNewToken(res.data.token));
            dispatch(setUserLoginDetails(res.data));
          }
        }
      }
    };
    if (
      cookies.MBB !== "undefined" &&
      cookies.MBB &&
      cookies.MBA !== "undefined" &&
      cookies.MBA
    ) {
      loadData();
    }

    const getCountryUser = async () => {
      //let res = await axios.get(API_URL + "getCountryUser");
      const res = await axiosInstance.get(
        "https://platform.betsfactory.co/api/getLocateConex"
      );
      let data = res.data;
      let country = data["Cf-Ipcountry"];
      console.log("c", country);
      
      if (!country) return;
      dispatch(setDetectedCountry(country));
      if (country === "BR" || country === "PT") {
        i18n.changeLanguage("pt");
        guardarIdioma("pt");
      }

      if (country === "US") setBlockPage(true);
    };
    getCountryUser();
  }, []);

  useEffect(() => {
    const hasATotalPagoTransaction = async () => {
      const res = await axios.post(API_URL + "checkDepositTotalPago", {
        id_uo,
        token,
      });
      if (res.data.status === 1) {
        if (res.data.response) {
          dispatch(setTotalPago(true));
          dispatch(setIdTotalPago(res.data.response));
        }
      }
    };

    const getLimitaciones = async () => {
      let body = { id_uo, token };
      try {
        const res = await axios.post(API_URL + "getLimitaciones", body);
        if (res.data.response !== null) {
          dispatch(setLimites(res.data.response));
          const fecha_config = res.data.response.fecha_config;
          const tiempo_inactivo = res.data.response.tiempo_inactivo;

          //validamos si se cumplio el tiempo de inactividad
          if (
            tiempo_inactivo > 0 &&
            fecha_config &&
            comprobarTiempoInactivo(fecha_config)
          ) {
            // se cumplio el tiempo de inactividad y lo seteamos a 0
            body = {
              ...body,
              ...limitaciones,
              tiempo_inactivo: 0,
              fecha_config: null,
            };
            const res = await axios.post(API_URL + "setLimitaciones", body);
            if (res.data.response === "ok") {
              dispatch(
                setLimites({
                  ...limitaciones,
                  tiempo_inactivo: 0,
                  fecha_config: null,
                })
              );
            }
          }
        }
      } catch (error) {
        //console.log(error);
      }
    };

    if (token && isLoged) {
      getLimitaciones();
    }

    if (token && isLoged && moneda === "Bs.S") {
      hasATotalPagoTransaction();
    }

    if (token !== "" && !isLoged) dispatch(setNewToken(""));

    if (token === "" && isLoged) {
      handleLogout();
    }
  }, [token, isLoged]);

  const handleLogout = () => {
    Swal.fire({
      title: t("home.sectionout"),
      text: "",
      icon: "warning",
      background: SECONDARY,
      color: "#fff",
      confirmButtonColor: PRIMARY,
      confirmButtonText: "Ok",
    }).then((result) => {
      dispatch(logout({}));
      dispatch(clearLimites({}));
      removeCookie("MBA");
      removeCookie("MBB");
      window.location.href = "/";
    });
  };

  useEffect(() => {
    const checkTransaction = async () => {
      const res = await axios.post(API_URL + "checkTransactionVeB", {
        id_uo,
        id_pago: id_totalPago,
      });
      if (res.data.estado === "exito") {
        dispatch(setTotalPago(false));
        dispatch(setIdTotalPago(null));
      } else if (res.data.estado === "rechazado") {
        if (res.data.causa === "N/A")
          errorNotification(
            t("alert.errorNotificationRetiro-46"),
            "top-center"
          );
        else
          errorNotification(
            t("alert.errorNotificationRetiro-46")`(${res.data.causa})`,
            "top-center"
          );

        dispatch(setTotalPago(false));
        dispatch(setIdTotalPago(null));
      }
    };
    if (totalPago && id_totalPago) {
      checkTransaction();
    }
  }, [totalPago]);

  return blockPage ? (
    <BlockPage />
  ) : (
    <Router>
      <>
        {isLoged && <WelcomeModal handleClose={handleClose} open={open} />}
        {completedBono && <CompletedBonoEffect />}

        {!hideNav && <Navbar />}

        <Suspense fallback={<LoaderFull />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/masterbets.php" element={<Home />} />
            <Route path="/Board" element={<Home />} />

            {/* Sin limitaciones */}
            <Route
              path={t("user-menu.link-6.url")}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="user" />
                )
              }
            />
            <Route
              path={t("user-menu.link-4.url")}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="movements" />
                )
              }
            />
            <Route
              path={t("user-menu.link-5.url")}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="history" />
                )
              }
            />
            <Route
              path={t("user-menu.link-10.url")}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="password" />
                )
              }
            />
            <Route
              path={"/settings"}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="settings" />
                )
              }
            />
            {(usuario === "test1" ||
              usuario === "test" ||
              usuario === "test2" ||
              usuario === "test3" ||
              usuario.toLowerCase() === "test4" ||
              usuario === "test5") && (
              <Route
                path={t("user-menu.link-3.url")}
                element={
                  !isLoged ? (
                    <Navigate to="/" replace />
                  ) : (
                    <Profile isLoged={isLoged} selected="wallets" />
                  )
                }
              />
            )}

            <Route
              path={t("user-menu.link-7.url")}
              element={
                !isLoged ? (
                  <Navigate to="/" replace />
                ) : (
                  <Profile isLoged={isLoged} selected="notifications" />
                )
              }
            />

            <Route
              path="/registro"
              element={
                !isLoged ? (
                  <Home registro={true} />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route
              path="/registro.php"
              element={
                !isLoged ? (
                  <Home registro={true} />
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route
              path="/login"
              element={<LoginPage setHideNav={setHideNav} />}
            />
            <Route
              path="/cambiarPassword"
              element={<CambiarPassword setHideNav={setHideNav} />}
            />
            <Route
              path="/completarDatos"
              element={<CompletarDatos setHideNav={setHideNav} />}
            />

            <Route path={t("footer.list-3.0.url")} element={<ContactForm />} />

            <Route
              path={t("footer.list-1.0.url")}
              element={<Policy active="terminos" />}
            />
            <Route
              path={t("footer.list-3.1.url")}
              element={<TermsAndConditions active="frequent" />}
            />

            <Route
              path={t("footer.list-1.2.url")}
              element={<Policy active="responsable" />}
            />
            <Route path="/Policy" element={<Policy active="policy" />} />
            <Route path="/Privacy" element={<Policy active="privacy" />} />
            <Route
              path="/Autoexclusion"
              element={<Policy active="autoexclusion" />}
            />
            <Route path="/Equidad" element={<Policy active="equidad" />} />
            <Route
              path="/Resolucion-de-conflictos"
              element={<Policy active="conflictos" />}
            />
            <Route
              path="/Cuentas-pagos-bonificaciones"
              element={<Policy active="cuentas" />}
            />

            <Route
              path={t("footer.list-4.2.url")}
              element={<TermsAndConditions active="hipismo" />}
            />

            <Route path={t("footer.list-2.0.url")} element={<JoinUs />} />
            {/* <Route path={t("footer.list-4.1.url")} element={<Tutorials />} /> */}
            <Route path={t("footer.list-4.0.url")} element={<Afiliados />} />

            {/* SEO */}
            <Route
              path="/casino-online-argentina"
              element={<SeoCasinoOnlineArgentina />}
            />
            <Route
              path="/casino-online-chile"
              element={<SeoCasinoOnlineChile />}
            />
            <Route
              path="/casino-online-ecuador"
              element={<SeoCasinoOnlineEcuador />}
            />
            <Route
              path="/casino-online-peru"
              element={<SeoCasinoOnlinePeru />}
            />
            <Route
              path="/casino-online-venezuela"
              element={<SeoCasinoOnlineVenezuela />}
            />
            <Route path="/casino-online" element={<SeoCasinoOnline />} />
            <Route path="/poker-online" element={<SeoPokerOnline />} />
            <Route path="/ruleta-online" element={<SeoRuletaOnline />} />
            <Route
              path="/apuestas-deportivas-chile"
              element={<ApuestasDeportivasChile />}
            />
            <Route
              path="/apuestas-deportivas-argentina"
              element={<ApuestasDeportivasArgentina />}
            />
            <Route
              path="/apuestas-deportivas-peru"
              element={<ApuestasDeportivasPeru />}
            />
            <Route
              path="/apuestas-deportivas-mexico"
              element={<ApuestasDeportivasMexico />}
            />
            <Route
              path="/apuestas-deportivas-online"
              element={<ApuestasDeportivasOnline />}
            />
            <Route
              path="/apuestas-deportivas-venezuela"
              element={<ApuestasDeportivasVenezuela />}
            />
            <Route
              path="/apuestas-deportivas-futbol"
              element={<ApuestasDeportivasFutbol />}
            />
            <Route
              path="/apuestas-deportivas-nba"
              element={<ApuestasDeportivasNBA />}
            />
            <Route
              path="/bingo-virtual-online"
              element={<BingoVirtualOnline />}
            />
            <Route
              path="/maquinas-tragamonedas-online"
              element={<MaquinasTragaMonedasOnline />}
            />
            <Route
              path="/dias-para-jugar-tragamonedas"
              element={<DiasParaJugarTragamonedas />}
            />
            <Route
              path="/jugar-blackjack-online"
              element={<JugarBlackjackOnline />}
            />
            <Route
              path="/mejores-casas-de-apuestas-deportivas"
              element={<MejoresCasasDeApuestasDeportivas />}
            />
            <Route
              path="/juegos-de-casino-online"
              element={<JuegosDeCasinoOnline />}
            />
            <Route
              path="/carreras-de-caballos-en-vivo"
              element={<SeoCarrerasDeCaballosEnVivo />}
            />
            {/* FIN SEO */}
            {/* Sin limitaciones */}

            {/* Se limitan */}
            {limitaciones.tiempo_inactivo <= 0 && (
              <>
                <Route path={t("header.link-1.url")} element={<Sports />} />
                <Route
                  path={t("header.link-1.url") + "/:type/:event"}
                  element={<Sports />}
                />
                <Route
                  path={t("header.link-1.url") + "/:type/:champ/:champion"}
                  element={<Sports />}
                />
                <Route
                  path={t("header.link-1.url") + "/*"}
                  element={<Sports />}
                />

                <Route path={"deportes/:type/:event"} element={<Sports />} />
                <Route
                  path={"deportes/:type/:champ/:champion"}
                  element={<Sports />}
                />
                <Route path={"deportes/*"} element={<Sports />} />

                <Route path={"esportes/:type/:event"} element={<Sports />} />
                <Route
                  path={"esportes/:type/:champ/:champion"}
                  element={<Sports />}
                />
                <Route path={"esportes/*"} element={<Sports />} />

                <Route path={"sports/:type/:event"} element={<Sports />} />
                <Route
                  path={"sports/:type/:champ/:champion"}
                  element={<Sports />}
                />
                <Route path={"sports/*"} element={<Sports />} />

                <Route path="/GoldenRace" element={<VirtualGolden />} />

                <Route
                  path={t("header.link-2.url")}
                  element={isLoged ? <Horses /> : <Navigate to="/" replace />}
                />

                <Route path={t("header.link-3.url")} element={<Virtuals />} />
                <Route
                  path={t("header.link-3.url") + "/:event"}
                  element={<Virtuals />}
                />
                <Route
                  path={t("header.link-3.url") + "/*"}
                  element={<Virtuals />}
                />

                {/* <Route path='/iframecasino' element={<Slotsiframetop setHideNav={setHideNav}/>} /> */}

                <Route path={t("header.link-4.url")} element={<Esports />} />
                {/* <Route path={t("header.link-4.url") + '/:event'} element={<Esports />} /> */}
                <Route
                  path={t("header.link-4.url") + "/*"}
                  element={<Esports />}
                />

                <Route
                  path={t("header.alrojovivo.url")}
                  element={<Alrojovivo />}
                />
                <Route
                  path={t("header.alrojovivo.url") + "/*"}
                  element={<Alrojovivo />}
                />

                <Route path={t("header.link-5.url")} element={<Slots />} />
                <Route
                  path={t("header.link-5.url") + "/:game"}
                  element={<Slots />}
                />
                <Route path={t("header.link-6.url")} element={<Casino />} />

                {country !== "PE" && (
                  <Route
                    path={t("header.link-7.url")}
                    element={!isLoged ? <Navigate to="/" replace /> : <Poker />}
                  />
                )}
                <Route
                  path={t("header.promotions.url")}
                  element={<Navigate to="/" replace />}
                />
                <Route path="*" element={<Error404 />} />
              </>
            )}

            {limitaciones.tiempo_inactivo > 0 && (
              <Route path="*" element={<CuentaInactiva />} />
            )}

            {notVerifiedPeru && (
              <Route path="*" element={<CuentaInactiva blockPeru={true} />} />
            )}
          </Routes>
        </Suspense>
        {!hideNav && <Footer />}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
          draggable
        />
      </>
    </Router>
  );
}

export default App;
